import React from 'react';
import { motion } from 'framer-motion';
import analyseVibratoire from '../Assets/analyse vabiratoire.png'; // Correction : "vabiratoire" → "Vibratoire"
import analyseVibratoire1 from '../Assets/analysevibratoire1.png'; // Correction : nom cohérent
import './Analysevibiratiore.css'; // Correction : "Analysevibiratiore" → "AnalyseVibratoire"

const AnalyseVibratoire = () => {
  const imageVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };

  const textVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: index * 0.3,
        ease: 'easeOut',
      },
    }),
  };

  return (
    <div className="solution-page-container">
      <div className="solution-header">
        <h1>Analyse Vibratoire</h1>
      </div>
      <div className="solution-content">
        {[
          {
            image: analyseVibratoire,
            alt: 'Analyse Vibratoire 1',
            description:
              'Nos solutions d’analyse vibratoire permettent de surveiller en continu l’état des machines et de détecter rapidement les anomalies telles que les déséquilibres, les défauts d’alignement ou les usures de roulements.',
          },
          {
            image: analyseVibratoire1,
            alt: 'Analyse Vibratoire 2',
            description:
              'Adaptées à différents secteurs industriels (automobile, agroalimentaire, énergie, métallurgie…), elles contribuent à prévenir les pannes, réduire les arrêts non planifiés et optimiser la maintenance. Grâce à des outils portables ou à des systèmes en ligne, nous vous aidons à améliorer la fiabilité et la performance de vos équipements.',
          },
        ].map((block, index) => (
          <div key={index} className="solution-block">
            <motion.div
              className="solution-block-image-container"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={imageVariants}
              custom={index}
            >
              <img src={block.image} alt={block.alt} className="solution-block-image" />
            </motion.div>
            <motion.div
              className="solution-block-text-container"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={textVariants}
              custom={index}
            >
              <p className="solution-block-description">{block.description}</p>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyseVibratoire;